
import { Quote } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Editor } from '@tiptap/react';

export default function BlockquoteButton({ editor }: { editor: Editor }) {
  return (
    <Button
      size="icon"
      variant={editor.isActive('blockquote') ? 'secondary' : 'ghost'}
      onClick={e => {
        e.preventDefault();
        editor.chain().focus().toggleBlockquote().run();
      }}
      className="h-8 w-8"
      title="Blockquote"
      type="button"
    >
      <Quote className="h-4 w-4" />
    </Button>
  );
}
